import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import AvatarDisplay from './profile/avatarDisplay'

function Profile () {
  const { user, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <div>Loading ...</div>;
  }
  
  return (
    !isLoading && isAuthenticated && (
      <AvatarDisplay user={user} />
    )
  );
};

export default Profile;